import './module.js';

// all currencies modules
import '../modules/module-load.js';


